import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  fullWidth = false,
  className = '',
  href,
  onClick,
  ...props
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    }
    if (onClick) {
      onClick(e);
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        relative overflow-hidden rounded-lg bg-gradient-to-r from-primary to-primary-hover
        px-8 py-4 font-heading text-xl font-bold text-white shadow-lg
        transition-all duration-300 hover:shadow-primary/50 animate-glow
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} onClick={handleClick} {...props} data-id="element-270">
      <div className="relative z-10 flex items-center justify-center gap-2" data-id="element-271">
        {children}
      </div>
      {/* Subtle shine effect on hover */}
      <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent transition-transform duration-500 hover:translate-x-full" data-id="element-272" />
    </motion.button>;
}